import { ChangeEvent, useCallback, useState } from "react";
import { getCustomerList, searchCustomer } from "src/apis/customerApi";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultPUR6010_R01Filter, usePUR6010_R01Store } from "src/containers/mes/PUR/PUR6010_R01/Store_PUR6010_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

export const SearchSection_PUR6010_R01 = () => {
	const { PUR6010_R01Filter, setPUR6010_R01Filter } = usePUR6010_R01Store();

    const { codeSearchModalVisible, setCodeSearchModalProps } = useUiuxStore();
	const { compCdList, customCdList, paycollectList } = useCommonCodeStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search';

    // 사업장(회사) 선택 핸들러
    const handleFilterCompanyChange = (selectedValue: string) => {
        setPUR6010_R01Filter({ compCd: selectedValue });
    }

	const handleFilterpaymentTypeChange = (selectedValue: string) => {
		setPUR6010_R01Filter({ tradeType: selectedValue });
	}
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},	
			extraFilter: () => ({
				customCd: PUR6010_R01Filter.customCd || '',
				customNm: PUR6010_R01Filter.customNm || '',
			}),
		},		
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR6010_R01Filter,
		setEditData: setPUR6010_R01Filter,
		defaultData: defaultPUR6010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR6010_R01_search'
	});

    // UI 렌더링
    return (
		<>
		<SearchSectionForm>
			{/* 사업장(회사) 선택 영역 */}
			<SearchDropDownForm
				label="사업장"
				value={PUR6010_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={handleFilterCompanyChange}
			/>
			<SearchDateRangeForm
				label="지불 기간"
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={PUR6010_R01Filter.paymentDateRange}		setDateRange={(dateRange) => setPUR6010_R01Filter({ paymentDateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchCodeModalForm
				label="거래처"
				value={PUR6010_R01Filter.customCd}
				valueLabel={PUR6010_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
			<SearchDropDownForm
				label="지불구분"
				value={PUR6010_R01Filter.tradeType}
				optionList={paycollectList}
				onChangeValue={handleFilterpaymentTypeChange}
			/>
		</SearchSectionForm>
		</>
	)
}

export default SearchSection_PUR6010_R01;